/**
 * Directory List/Map SSOT: `view=map` query (same key as browse discovery).
 * `location.hash` is not used for map context — do not invent a hash router.
 */

export const DIRECTORY_VIEW_PARAM = 'view';
export type DirectoryViewMode = 'list' | 'map';

export function parseDirectoryViewMode(search: string): DirectoryViewMode {
  const raw = search.startsWith('?') ? search.slice(1) : search;
  const params = new URLSearchParams(raw);
  return params.get(DIRECTORY_VIEW_PARAM) === 'map' ? 'map' : 'list';
}

/** Ensure `view=map` on a path+query park (preserves other params; drops hash). */
export function withDirectoryMapViewQuery(pathWithQuery: string): string {
  const withoutHash = pathWithQuery.split('#', 1)[0] ?? pathWithQuery;
  const qIndex = withoutHash.indexOf('?');
  const pathname = qIndex === -1 ? withoutHash : withoutHash.slice(0, qIndex);
  const search = qIndex === -1 ? '' : withoutHash.slice(qIndex + 1);
  const params = new URLSearchParams(search);
  params.set(DIRECTORY_VIEW_PARAM, 'map');
  const next = params.toString();
  return next.length > 0 ? `${pathname}?${next}` : `${pathname}?view=map`;
}

export function withDirectoryViewModeInSearch(
  search: string,
  view: DirectoryViewMode,
): string {
  const raw = search.startsWith('?') ? search.slice(1) : search;
  const params = new URLSearchParams(raw);
  if (view === 'map') {
    params.set(DIRECTORY_VIEW_PARAM, 'map');
  } else {
    params.delete(DIRECTORY_VIEW_PARAM);
  }
  const next = params.toString();
  return next.length > 0 ? `?${next}` : '';
}
